import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import dayjs from 'dayjs';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { showNotification } from '../../../redux/commonSlice';
import { useAppDispatch } from '../../../store/hooks';
import { fetchFutureAdviceTypes, fetchStatusByEntityId } from '../../futureAdvise/apiCalls';
export function useFutureAdviseElements() {
    var dispatch = useAppDispatch();
    var futureAdviseElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '10px',
            rowSpacing: 2,
            columnSpacing: 2,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'FutureAdviceTypeId',
                    label: 'FA type',
                    getListData: fetchFutureAdviceTypes,
                    apiKey: 'futureAdviseTypes',
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    xs: 12,
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.Name) || ''; },
                    valueSetter: function (formValues, currValue) {
                        var _currValue$Name, _currValue$id;
                        if (!currValue) {
                            return _objectSpread(_objectSpread({}, formValues), {}, {
                                FutureAdviceTypeId: null,
                                FutureAdviceTypeName: null,
                                DueDate: null,
                                StatusId: null,
                                StatusName: null
                            });
                        }
                        return _objectSpread(_objectSpread({}, formValues), {}, {
                            FutureAdviceTypeName: (_currValue$Name = currValue === null || currValue === void 0 ? void 0 : currValue.Name) !== null && _currValue$Name !== void 0 ? _currValue$Name : '',
                            FutureAdviceTypeId: (_currValue$id = currValue === null || currValue === void 0 ? void 0 : currValue.id) !== null && _currValue$id !== void 0 ? _currValue$id : null
                        });
                    },
                    valueGetter: function (formValues) {
                        var _formValues$FutureAdv;
                        return (_formValues$FutureAdv = formValues === null || formValues === void 0 ? void 0 : formValues.FutureAdviceTypeId) !== null && _formValues$FutureAdv !== void 0 ? _formValues$FutureAdv : null;
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'SuggestionContent',
                    label: 'Future advise details',
                    minRows: 3,
                    value: null,
                    multiline: true,
                    xs: 12,
                    setFieldProps: function (formValues) {
                        return {
                            disabled: !(formValues !== null && formValues !== void 0 && formValues.FutureAdviceTypeId)
                        };
                    },
                    validator: function (value, state) {
                        if (!(state !== null && state !== void 0 && state.FutureAdviceTypeId)) {
                            return ''; // Skip validation if FA type not selected
                        }
                        if (!value) {
                            return "You\u2019ve added a future advice line. Please provide the details or remove the line to proceed ";
                        }
                        if (value.length > 1000) {
                            return 'Future Advice Details cannot exceed 1000 characters.';
                        }
                        return '';
                    }
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'DueDate',
                    label: 'Due date',
                    value: null,
                    xs: 12,
                    setFieldProps: function (formValues) {
                        return {
                            disabled: !(formValues !== null && formValues !== void 0 && formValues.FutureAdviceTypeId),
                            disablePast: true
                        };
                    },
                    validator: function (value, state) {
                        if (!(state !== null && state !== void 0 && state.FutureAdviceTypeId)) {
                            return '';
                        }
                        if (!value) {
                            return "Please enter a due date for the all Future Advice.";
                        }
                        var today = dayjs().startOf('day');
                        var selectedDate = dayjs(value).startOf('day');
                        if (selectedDate.isBefore(today)) {
                            return 'Past due date is not allowed. Please select present or future date.';
                        }
                        return '';
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'StatusId',
                    label: 'Status',
                    getListData: fetchStatusByEntityId,
                    apiKey: 'statusByEntityId',
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    xs: 12,
                    getOptionLabel: function (option) { return (option === null || option === void 0 ? void 0 : option.Name) || ''; },
                    setFieldProps: function (formValues) {
                        return {
                            disabled: !(formValues !== null && formValues !== void 0 && formValues.FutureAdviceTypeId)
                        };
                    },
                    valueSetter: function (formValues, currValue) {
                        var _currValue$id2, _currValue$Name2;
                        if (!currValue) {
                            dispatch(showNotification({
                                isOpen: true,
                                message: 'Status cannot be deleted.',
                                type: 'warning'
                            }));
                            return _objectSpread({}, formValues);
                        }
                        return _objectSpread(_objectSpread({}, formValues), {}, {
                            StatusId: (_currValue$id2 = currValue === null || currValue === void 0 ? void 0 : currValue.id) !== null && _currValue$id2 !== void 0 ? _currValue$id2 : null,
                            StatusName: (_currValue$Name2 = currValue === null || currValue === void 0 ? void 0 : currValue.Name) !== null && _currValue$Name2 !== void 0 ? _currValue$Name2 : ''
                        });
                    },
                    valueGetter: function (formValues) {
                        var _formValues$StatusId;
                        return (_formValues$StatusId = formValues === null || formValues === void 0 ? void 0 : formValues.StatusId) !== null && _formValues$StatusId !== void 0 ? _formValues$StatusId : null;
                    },
                    validator: function (value, state) {
                        if (!(state !== null && state !== void 0 && state.FutureAdviceTypeId)) {
                            return '';
                        }
                        if (!value || !(state !== null && state !== void 0 && state.StatusId)) {
                            return 'Status is required.';
                        }
                        return '';
                    }
                }]
        }];
    return futureAdviseElements;
}
